import { isRejected } from '@reduxjs/toolkit';
import { put, takeEvery } from 'redux-saga/effects';
import { call } from 'typed-redux-saga';
import { CoreActionKeys, InitApp } from '..';
import { errorLogger, store } from '../../..';
import { authActionCreators } from '../../auth';
import { FetchPermissions } from '../../auth/authApi';
import { fetchConfigThunk } from '../../config';
import { meActionCreators } from '../../me';
import { FetchMe } from '../../me/meApi';
import { uiActionCreators } from '../../ui';
import { coreActionCreators } from '../coreActionCreators';

function* initApp(action: InitApp) {
  yield put(authActionCreators.setLoggedIn());
  yield put(uiActionCreators.showSplashPage());

  const fetchConfig = async (): Promise<void> => {
    const val = await store.dispatch(fetchConfigThunk());
    if (isRejected(val)) {
      throw val.error;
    }
  };
  try {
    const [user, permissionResponse] = yield* call(async () =>
      Promise.all([FetchMe(), FetchPermissions(), fetchConfig()])
    );
    if (user) {
      if (user.mail && user.displayName) {
        errorLogger.setUser(user.mail, user.displayName);
      }
      yield put(meActionCreators.setMe(user));
    }
    if (permissionResponse && permissionResponse.value) {
      yield put(authActionCreators.setPermissions(permissionResponse.value));
    }
    yield put(coreActionCreators.appInitialized());
  } catch (e) {
    yield put(authActionCreators.toggleLoginFailed());
  }

  yield put(uiActionCreators.hideSplashPage());
}

export function* watchInitApp() {
  yield takeEvery(CoreActionKeys.INIT_APP, initApp);
}
